export default __webpack_public_path__ + "static/media/site-search.86689275.png";